import { API_BASE_URL } from "../../constants/index";
import HttpInterface from "../../helpers/HttpInterface";

export class IncomingGoodDetailsService {
  private httpProxy: HttpInterface;
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  /**
   * Retrieves movement details for a specific barcode from the logistic service.
   *
   * Makes a GET request to the `/barcode-movements` endpoint with the provided barcode
   * to fetch a log of movements related to incoming goods.
   *
   * @param {string} barcode - The barcode for which to retrieve movement history.
   * @returns A promise that resolves to a string containing movement data.
   */
  barcodeMovements(barcode: string): Promise<any> {
    const requestOptions = {
      method: "GET",
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/logistic-service/incoming-goods-detail/barcode-movements/${barcode}`,
      requestOptions
    );
  }
}
